import React, {Component, useEffect, useState} from 'react'
import CalculationHelper from '../../../components/admin/table_session/helper/CalculationHelper'
import { getMembershipTransactionTypeDesc, MembershipTransactionType } from '../../../components/merchant/Enum/MembershipTransactionType'
import CreateMembershipTransactionModal from '../../../jsx/modal/CreateMembershipTransactionModal'
import MerchantAppData from '../../../Model/MerchantAppData'
import MembershipRepository from '../Repository/MembershipRepository'
import './MembershipTable.scss'
import BaseModal from "../../../jsx/modal/BaseModal";
import MembershipFreeItemRepository from "../Repository/MembershipFreeItemRepository";

export default class MembershipTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            memberships: [],
        }

        this.callbackKey = "MembershipTable"
    }
    componentDidMount() {
        this.loadMemberships()
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.searchText != this.props.searchText) {
            this.loadMembershipByTimer()
        }
        if (prevState.memberships !== this.state.memberships || prevState.selectedMembership !== this.state.selectedMembership) {
            this.updateSelectedMembership()
        }
    }
    loadMembershipByTimer = () => {
        if (this.timer) {
            clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
            this.loadMemberships()
        }, 1500);
    }
    componentWillUnmount = () => {
        MembershipRepository.getInstance().removeCallback(null, this)
    }
    selectMembership = (selectedMembership) => {
        this.setState({
            selectedMembership: selectedMembership,
        })
        this.props.selectMembership && this.props.selectMembership(selectedMembership)
    }
    updateSelectedMembership = () => {
        const { memberships, } = this.state
        let selectedMembership = this.state.selectedMembership
        if (memberships.length == 0 || (selectedMembership && !memberships.find(m => m.id == selectedMembership.id))) {
            this.selectMembership(null)
        }
    }
    reloadMembershipList = () => {
        if (this.props.searchText) {
            MembershipRepository.getInstance().loadSome({search: this.props.searchText}, memberships => {
                memberships = [...memberships]
                this.setState({memberships})
            }, this.callbackKey, this)
        }
        else {
            MembershipRepository.getInstance().reloadData()
        }
    }
    loadMemberships = () => {
        const membershipLoaded = (memberships) => {
            memberships = [...memberships]
            this.setState({memberships})
        }
        if (this.props.searchText) {
            MembershipRepository.getInstance().loadSome({search: this.props.searchText}, memberships => {
                membershipLoaded(memberships)
            }, this.callbackKey, this)
        }
        else {
            MembershipRepository.getInstance().loadAll(memberships => {
                membershipLoaded(memberships)
            }, this.callbackKey, this)
        }
    }
    onEditMembershipClicked = (membership) => {
        this.props.onEditMembershipClicked && this.props.onEditMembershipClicked(membership)
    }
    onCreateMembershipTransactionClicked = (membership) => {
        if (!this.createMembershipTransactionModalRef) {
            this.createMembershipTransactionModalRef = React.createRef()
        }
        const onClose = () => {
            this.createMembershipTransactionModalRef && this.createMembershipTransactionModalRef.current && this.createMembershipTransactionModalRef.current.close(true)
            setTimeout(() => {
                this.setState({
                    createMembershipTransactionModal: null,
                })
            }, 200);
        }
        this.setState({
            createMembershipTransactionModal: <CreateMembershipTransactionModal
                app={this.props.app}
                ref={this.createMembershipTransactionModalRef}
                membership={membership}
                // variationTemplate={variationTemplateToEdit}
                autoShow={true}
                onModalClosed={onClose}
                onNo={onClose}
                onYes={(membership) => {
                    this.createMembershipTransactionModalRef && this.createMembershipTransactionModalRef.current && this.createMembershipTransactionModalRef.current.close(true)
                    setTimeout(() => {
                        onClose()
                    }, 500);
                }}
            />
        })
    }
    isCustomColumn = (columnKey) => {
        return ["expire_at", "last_txn_at"].indexOf(columnKey) !== -1
    }
    renderCustomColumn = (membership, columnKey, columnAction) => {
        const formatDate = (dateStr) => {
            return moment(dateStr).format('YYYY-MM-DD')
        }

        if (columnAction) {
            let columnActions = columnAction
            if (!Array.isArray(columnAction)) {
                columnActions = [columnAction]
            }
            return <td key={columnActions.join(",")} className="gap-5">
                {
                    columnActions.map(action => {
                        switch (action) {
                            case "create_membership_transaction":
                                return <button key={action} className="btn btn-sm btn-default" style={{padding: "1px 10px"}}
                                               onClick={() => this.onCreateMembershipTransactionClicked(membership)}>
                                    <span style={{fontSize: "150%"}}>&#43;</span>
                                </button>
                            case "edit_membership":
                                return <button key={action} className="btn btn-sm btn-default"
                                               onClick={() => this.onEditMembershipClicked(membership)}>
                                    <span><i className="fa fa-edit"/></span>
                                </button>
                        }
                    })
                }
            </td>
        } else {
            let colValue = membership[columnKey]
            if (columnKey == 'expire_at') {
                return <td key={columnKey}>{formatDate(colValue)}</td>
            }
            else if (columnKey == 'last_txn_at') {
                const bill = membership.last_transaction && membership.last_transaction.bill
                return <td key={columnKey}>
                    <div>{formatDate(colValue)}</div>
                    {
                        bill && bill.table_session_id && 
                        <div><a href={`/merchant/preview_receipt/${bill.table_session_id}`} target="_blank">
                            {`${MerchantAppData.data.state.currencyName} ${CalculationHelper.round2dp(parseFloat(bill.total)).toFixed(2)}`}
                        </a></div>
                    }
                    {
                        !bill && membership.last_transaction && membership.last_transaction.txn_type == MembershipTransactionType.TOPUP &&
                        <div>
                            {getMembershipTransactionTypeDesc(membership.last_transaction.txn_type)} {membership.last_transaction.point} {lang.point}
                        </div>
                    }
                </td>
            }
            // Default
            return colValue
        }
    }

    onMembershipBenefitDetailClicked = (membershipFreeItem) => {
        const onClose = () => {
            this.setState({
                membershipFreeItemDetailModal: null,
            })
        }
        this.setState({
            membershipFreeItemDetailModal: <BaseModal
                onClose={onClose}
                body={<MembershipFreeItemDetailBody membershipFreeItem={membershipFreeItem} />}
            />
        })
    }
    render() {
        const { memberships, selectedMembership, } = this.state
        return (
            <div id="select-membership-modal-table-container">
                {this.state.createMembershipTransactionModal}
                {this.state.membershipFreeItemDetailModal}
                <table id="select-membership-modal-table" className="table table-bordered">
                    <thead>
                        <tr>
                            {
                                this.props.isAllowSelect &&
                                <th>&nbsp;</th>
                            }
                            <th>{lang.name}</th>
                            <th>{lang.phone_number}</th>
                            <th>{lang.membership_card_no}</th>
                            <th>{lang.point}</th>
                            <th>{lang.rate}</th>
                            {
                                (this.props.extraColumns || []).map(col => {
                                    if (col.action) {
                                        return <th key={"action"+col.key}>{col.header}</th>
                                    }
                                    else {
                                        return <th key={col.key}>{col.header}</th>
                                    }
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            memberships.length === 0 ?
                            <tr><td colSpan={6} className="row-no-data">{lang.no_data}</td></tr> :
                            memberships.map(membership => {
                                const isSelected = !!selectedMembership && membership.id == selectedMembership.id
                                let className = isSelected ? "bg-primary bg-table-row-selected" : ""
                                return <tr className={className} key={membership.id} onClick={() => this.props.isAllowSelect && this.selectMembership(membership)}>
                                    {
                                        this.props.isAllowSelect &&
                                        <td>
                                            <input type="checkbox" checked={isSelected} readOnly />
                                        </td>
                                    }
                                    <td>{membership.name}</td>
                                    <td>{membership.phone_number}</td>
                                    <td>
                                        <div>
                                            <div>{membership.membership_number}</div>
                                            {
                                                !!membership.membership_benefits && membership.membership_benefits.length > 0 &&
                                                <table className="mt-2 membership-benefit-mini-table">
                                                    <tbody>
                                                        {membership.membership_benefits.map(benefit => {
                                                            const membershipFreeItem = membership.membership_free_items && membership.membership_free_items.find(item => item.membership_benefit_id === benefit.pivot.membership_benefit_id)
                                                            let key = benefit.id+"_"+benefit.pivot.id
                                                            return <tr key={key}>
                                                                <td>{benefit.name}</td>
                                                                <td onClick={() => this.onMembershipBenefitDetailClicked(membershipFreeItem)} className="clickable">
                                                                    {membershipFreeItem && <span className="ml-2">({membershipFreeItem.balance_quantity} remaining / {membershipFreeItem.total_quantity} total)</span>}
                                                                </td>
                                                            </tr>
                                                        })}
                                                    </tbody>
                                                </table>
                                            }
                                        </div>
                                    </td>
                                    <td>{membership.points || 0}</td>
                                    <td>
                                        <div className="text-danger">{membership.redeem_rate} {lang.point} = {MerchantAppData.data.state.currencyName} 1 </div>
                                        <div  className="text-success">{MerchantAppData.data.state.currencyName} 1 = {membership.earn_rate} {lang.point}</div>
                                    </td>
                                    {
                                        (this.props.extraColumns || []).map(col => {
                                            if (col.action || (membership[col.key] && this.isCustomColumn(col.key))) {
                                                return this.renderCustomColumn(membership, col.key, col.action)
                                            }
                                            else {
                                                return <td key={col.key}>{membership[col.key]}</td>
                                            }
                                        })
                                    }
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
  }
}

const MembershipFreeItemDetailBody = ({membershipFreeItem}) => {
    const [orders, setOrders] = useState([])
    useEffect(() => {
        MembershipFreeItemRepository.getInstance().getClaimedItems(membershipFreeItem.id)
            .then((res) => {
                const orders = [...res[0].orders]
                // Sort desc
                orders.sort((a, b) => moment(b.bills[0].updated_at).diff(moment(a.bills[0].updated_at)))
                setOrders(orders || [])
            })
            .catch(({ errorCode, message, json }) => {
                alert(message || errorCode || (json && JSON.stringify(json)))
            })
    }, [])
    return <div>
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th>Item Name</th>
                    <th>Bill ID</th>
                    <th>Price</th>
                    <th>Bill Date</th>
                </tr>
            </thead>
            <tbody>
            {
                orders.map(order => {
                    return <tr key={order.id}>
                        <td>{order.desc}</td>
                        <td>
                            {
                                order.table_session_id &&
                                <div><a href={`/merchant/preview_receipt/${order.table_session_id}`} target="_blank">
                                    {order.table_session_id}
                                </a></div>
                            }
                        </td>
                        <td>{`${MerchantAppData.data.state.currencyName} ${CalculationHelper.round2dp(parseFloat(order.order_total)).toFixed(2)}`}</td>
                        <td>{moment(order.bills[0].updated_at).format('YYYY-MM-DD hh:mm a')}</td>
                    </tr>
                })
            }
            </tbody>
        </table>
    </div>
}

MembershipTable.defaultProps = {
    isAllowSelect: true,
}